import React from 'react';
import { clsx } from 'clsx';

import LoadingSpinner from '@components/loading-spinner';

// styles
import css from './styles.module.css';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  color?: 'primary' | 'secondary' | 'danger' | 'grey' | 'link';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
}

const Button = (props: ButtonProps) => {
  const {
    children,
    onClick,
    disabled = false,
    className,
    type = 'button',
    color = 'primary',
    size = 'medium',
    loading = false,
  } = props;

  const cn = clsx(
    css.btn,
    {
      [css.btnPrimary]: color === 'primary',
      [css.btnSecondary]: color === 'secondary',
      [css.btnGrey]: color === 'grey',
      [css.btnLink]: color === 'link',
    },
    {
      [css.small]: size === 'small',
      [css.medium]: size === 'medium',
      [css.large]: size === 'large',
    },
    className,
  );

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={cn}>
      {loading && <LoadingSpinner />}
      {children}
    </button>
  );
};

export default Button;
